import { render, staticRenderFns } from "./FingerPrintSideBox.vue?vue&type=template&id=62793ea0&scoped=true"
import script from "./FingerPrintSideBox.vue?vue&type=script&lang=js"
export * from "./FingerPrintSideBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62793ea0",
  null
  
)

export default component.exports